import type { CustomerStore } from '@stores/me/customer/interfaces'
import type { Customer } from '@brighterly/lib-core-types/customer/interfaces'

import { _fetchCustomer } from './fetch-customer'
import { _setCustomer } from './set-customer'

export const _fetchCustomerAfterAuth = async (state: CustomerStore, silent: boolean): Promise<Customer | null> => {
  const customer: CustomerStore['customer'] | null = await _fetchCustomer(state, silent).catch(() => null)
  if (!customer) return null

  _setCustomer(state, customer)

  return customer
}
